import React from "react";
import { LoadingIndicator } from "elements";

const Loader: React.FC<{
  loading: boolean;
  className?: string;
}> = ({ loading, className, children }) =>
  loading ? <LoadingIndicator className={className} /> : <>{children}</>;

export default Loader;
